import { render, staticRenderFns } from "./customProducto.vue?vue&type=template&id=5326c329&scoped=true"
import script from "./customProducto.vue?vue&type=script&lang=js"
export * from "./customProducto.vue?vue&type=script&lang=js"
import style0 from "./customProducto.vue?vue&type=style&index=0&id=5326c329&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5326c329",
  null
  
)

export default component.exports